import { useContext } from "react";
import { Text } from "../../components/text/text";
import { LocaleContext } from "../../contexts/locale/locale";
import { Page } from "../page/page";

export const Disclaimer = () => {
	const { texts } = useContext(LocaleContext);

	return (
		<Page title={texts.disclaimer.hero.title} image="/images/home.jpg">
			<Text
				title={texts.disclaimer.hero.title}
				paragraphs={texts.disclaimer.paragraphs}
			/>
		</Page>
	);
};
